/**
 * Converts values from cm to feet/inches
 * @param {string} centimetres A string that contains an integer representing
 *
 * @returns {object} The resulting object should be { feet, inches }
 */
const decomposeHeightImperialToMetric = centimetres => {
  if (typeof centimetres === 'undefined') {
    return { feet: '', inches: '' };
  }
  const parsedCentimeters = centimetres || 0;

  const wholeInches = parsedCentimeters / 2.54;
  const parsedFeet = Math.floor(wholeInches / 12);
  const parsedInches = Math.round(wholeInches % 12);

  return {
    feet: parsedFeet,
    inches: parsedInches,
  };
};

export default decomposeHeightImperialToMetric;
